// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hctktgtkVIIMKZvONfzu{text-align:center}.LiKX5Kc1d3EXJl4ARB6c{z-index:var(--zIndex-BASE_10);width:100%;height:100%;display:flex}.LiKX5Kc1d3EXJl4ARB6c.gjix2wk0XOcjRYY2lnDg{position:fixed}.LiKX5Kc1d3EXJl4ARB6c.wrB9apf_Atcw2wiSrNQE{position:absolute}.LiKX5Kc1d3EXJl4ARB6c.qlzXWir6k8VzKgLEhL9o{justify-content:end;align-items:end}.LiKX5Kc1d3EXJl4ARB6c.nfEIlGIbh1wUGsiHPzJC{justify-content:end;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.lN_j34afnQrwDAIOyqBM{justify-content:end;align-items:center}.LiKX5Kc1d3EXJl4ARB6c.NSD1Ue7iNsE2bDE7RdRV{justify-content:start;align-items:end}.LiKX5Kc1d3EXJl4ARB6c.S8IUJLlX41CQPdj9U9Qd{justify-content:start;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.UUuDTxcdBLgwdUDumTqT{justify-content:start;align-items:center}.LiKX5Kc1d3EXJl4ARB6c.pjkNaE9xNkoRn50bs0nl{justify-content:end;align-items:end}.LiKX5Kc1d3EXJl4ARB6c.rrjRuCoiU3MCZZkvkx38{justify-content:end;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.LOjvoUmI8i4m6LBZ7AyE{justify-content:end;align-items:center}.LiKX5Kc1d3EXJl4ARB6c.WtJKJ97rHH0ZuhC0hRFj{justify-content:end;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.ZH6uDdidsgg9lhgkzeb5{justify-content:start;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.xQXmtw9ooAw2F40ix0YW{justify-content:center;align-items:start}.LiKX5Kc1d3EXJl4ARB6c.C29gGjBOPG4KisqELOEi{justify-content:center;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `hctktgtkVIIMKZvONfzu`,
	"container": `LiKX5Kc1d3EXJl4ARB6c`,
	"fixed": `gjix2wk0XOcjRYY2lnDg`,
	"absolute": `wrB9apf_Atcw2wiSrNQE`,
	"bottom-end": `qlzXWir6k8VzKgLEhL9o`,
	"bottomEnd": `qlzXWir6k8VzKgLEhL9o`,
	"bottom-start": `nfEIlGIbh1wUGsiHPzJC`,
	"bottomStart": `nfEIlGIbh1wUGsiHPzJC`,
	"bottom": `lN_j34afnQrwDAIOyqBM`,
	"left-end": `NSD1Ue7iNsE2bDE7RdRV`,
	"leftEnd": `NSD1Ue7iNsE2bDE7RdRV`,
	"left-start": `S8IUJLlX41CQPdj9U9Qd`,
	"leftStart": `S8IUJLlX41CQPdj9U9Qd`,
	"left": `UUuDTxcdBLgwdUDumTqT`,
	"right-end": `pjkNaE9xNkoRn50bs0nl`,
	"rightEnd": `pjkNaE9xNkoRn50bs0nl`,
	"right-start": `rrjRuCoiU3MCZZkvkx38`,
	"rightStart": `rrjRuCoiU3MCZZkvkx38`,
	"right": `LOjvoUmI8i4m6LBZ7AyE`,
	"top-end": `WtJKJ97rHH0ZuhC0hRFj`,
	"topEnd": `WtJKJ97rHH0ZuhC0hRFj`,
	"top-start": `ZH6uDdidsgg9lhgkzeb5`,
	"topStart": `ZH6uDdidsgg9lhgkzeb5`,
	"top": `xQXmtw9ooAw2F40ix0YW`,
	"center": `C29gGjBOPG4KisqELOEi`
};
export default ___CSS_LOADER_EXPORT___;
